import type { IMenuItem } from 'atoms';
import { IMenuStructure, MenuCounter, MenuItems } from 'context';

export interface IMenuCounts {
  groups: number;
  unpaidInvoices: number;
}

export type TransformedMenuItem = IMenuStructure & IMenuItem;

/**
 * Пункты меню → пропсы MenuItem. Каждый пункт получает СВОЙ счётчик
 * (IMenuStructure.counter): число групп у курсов, красный кружок неоплаченных
 * фактур у «Moje faktury» (ТЗ 0074). Пункт без counter счётчика не получает.
 */
export const transformMenu = (
  menu: IMenuStructure[],
  counts: IMenuCounts,
  activeMenuItem: MenuItems | undefined,
  unpaidInvoicesLabel?: string,
): TransformedMenuItem[] =>
  menu.map((menuItem) => {
    const item = { ...menuItem, isActive: menuItem.name === activeMenuItem };
    switch (menuItem.counter) {
      case MenuCounter.groups:
        return { ...item, subMenuCount: counts.groups };
      case MenuCounter.unpaidInvoices:
        return {
          ...item,
          subMenuCount: counts.unpaidInvoices,
          countVariant: 'alert',
          countLabel: unpaidInvoicesLabel,
        };
      default:
        return item;
    }
  });

/**
 * ТЗ 0074: приостановленному студенту в меню остаётся только «Moje faktury» —
 * всё остальное сервер ему не отдаёт, а гард маршрутов туда не пустит.
 */
export const suspendedStudentMenu = (menu: IMenuStructure[]): IMenuStructure[] =>
  menu.filter((item) => item.name === MenuItems.Invoices);
